// Action Types

export const Types = {
  LOGIN: 'auth/LOGIN',
  LOGOUT: 'auth/LOGOUT'
};

// Reducer
const initialState = {
  isLogged: false,
  token: null,
  perfil:  null,
  url: null,
  user: {}
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case Types.LOGIN:
      return { ...state, ...action.payload };
    case Types.LOGOUT:
      return initialState;
    default:
      return state;
  }
}

// Action Creators
export function login(user, perfil, token, url) {
  return {
    type: Types.LOGIN,
    payload: {
      isLogged: true,
      token,
      perfil,
      url,
      user: {
        ...user
      }
    }
  };
}

export function logout() {
  return {
    type: Types.LOGOUT
  };
}
